import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import get from 'lodash/get';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import Button from 'react-bootstrap-button-loader';
import { toastr } from 'react-redux-toastr';
import {
  InputField,
  DateField,
  SelectField,
  required,
  parseDecimal,
  minValue,
  number,
  url,
  dateBfrToday
} from '../../form';


class AdDetailsForm extends Component {
  resetForm() {
    const { reset } = this.props;

    reset();
    toastr.success('Ad Draft Changes reverted');
  }
  render() {
    const { onSubmit, categories, handleSubmit, isLoading } = this.props;
    return (
      <form className='ad-detail-form' onSubmit={handleSubmit(onSubmit)}>
        <Row className='ad-detail-row'>
          <Col xs={3} className='ad-detail-label'>
            <ControlLabel>Title:</ControlLabel>
          </Col>
          <Col xs={9}>
            <Field
              type='text'
              name='title'
              component={InputField}
              validate={[required]}
            />
          </Col>
        </Row>
        <Row className='ad-detail-row'>
          <Col xs={3} className='ad-detail-label'>
            <ControlLabel>Company:</ControlLabel>
          </Col>
          <Col xs={9}>
            <Field
              type='text'
              name='company'
              component={InputField}
              validate={[required]}
            />
          </Col>
        </Row>
        <Row className='ad-detail-row'>
          <Col xs={3} className='ad-detail-label'>
            <ControlLabel>Description:</ControlLabel>
          </Col>
          <Col xs={9}>
            <Field
              type='text'
              name='description'
              textarea
              component={InputField}
              validate={[required]}
            />
          </Col>
        </Row>
        <Row className='ad-detail-row'>
          <Col xs={3} className='ad-detail-label'>
            <ControlLabel>Category:</ControlLabel>
          </Col>
          <Col xs={9}>
            <Field
              type='text'
              name='category'
              component={SelectField}
              options={categories}
              validate={[required]}
            />
          </Col>
        </Row> 
        <Row className='ad-detail-row'>
          <Col xs={3} className='ad-detail-label'>
            <ControlLabel>Bid($):</ControlLabel>
          </Col>
          <Col xs={9}>
            <Field
              type='number'
              name='bid'
              validate={[required, number, minValue(0.01)]}
              component={InputField}
              normalize={(value) => {
                return parseDecimal(value);
              }}
            />
          </Col>
        </Row>    
        <Row className='ad-detail-row'>
          <Col xs={3} className='ad-detail-label'>
            <ControlLabel>URL:</ControlLabel>
          </Col>
          <Col xs={9}>
            <Field
              type='text'
              name='url'
              component={InputField}
              validate={[required, url]}
            />
          </Col>
        </Row>
        <Row className='ad-detail-row'>
          <Col xs={3} className='ad-detail-label'>
            <ControlLabel>Location:</ControlLabel>
          </Col>
          <Col xs={9}>
            <Field
              type='text'
              name='location'
              component={InputField}
              validate={[required]}
            />
          </Col>
        </Row>
        <Row className='ad-detail-row'>
          <Col xs={3} className='ad-detail-label'>
            <ControlLabel>Video URL:</ControlLabel>
          </Col>
          <Col xs={9}>
            <Field
              type='text'
              name='video_url'
              component={InputField}
              validate={[url]}
            />
          </Col>
        </Row>
        <Row className='ad-detail-row'>
          <Col xs={3} className='ad-detail-label'>
            <ControlLabel>Post Date:</ControlLabel>
          </Col>
          <Col xs={9}>
            <Field
              type='text'
              name='post_date'
              component={DateField}
              validate={[dateBfrToday]}
              placement='top'
            />
          </Col>
        </Row>
        <Row className='ad-detail-row'>
          <Col className='text-right' style={{ paddingRight: '25px' }} xs={12}>
            <Button 
              style={{ marginRight: '10px' }}
              onClick={this.resetForm.bind(this)}
              loading={isLoading}
              bsStyle='warning'
            > 
              Reset
            </Button>
            <Button 
              type="submit"
              loading={isLoading}
              bsStyle='primary'
            >
              Save Draft
            </Button>
          </Col>
        </Row>
      </form>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'adDetailsForm'
});

const mapStateToProps = (state) => {
  const { loader, advertiser: { jobs: { data: jobs } } } = state;
  const isLoading = loader.includes('adDetailsForm');
  const categories = get(jobs, 'meta.categories', []).map(c => {
    return { label: c, value: c };
  });

  return {
    categories,
    isLoading
  };
};

export default connect(mapStateToProps)(ResourceForm(AdDetailsForm));
